export const timeScales = {
  DAY: "DAY",
  WEEK: "WEEK",
  MONTH: "MONTH",
  QUARTER: "QUARTER",
} as const;

export type TimeScale = (typeof timeScales)[keyof typeof timeScales];

export const DEFAULT_TIME_SCALE: TimeScale = timeScales.MONTH;

export interface TimeScaleOption {
  label: string;
  value: TimeScale;
}

export const timeScaleValues: TimeScaleOption[] = [
  {
    label: "Weekly",
    value: timeScales.WEEK,
  },
  {
    label: "Monthly",
    value: timeScales.MONTH,
  },
  {
    label: "Quarterly",
    value: timeScales.QUARTER,
  },
];
